"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createRunnableProcess_1 = __importDefault(require("../shared/createRunnableProcess"));
const executeProcessesFactory_1 = __importDefault(require("./executeProcessesFactory"));
const buildFunctionEvaluator = ({ store, processor, functionEntryVar, controlCallerId, eventOutputs, lastFunctionsOutputs, itemContext, functionsDefinitions, }) => new Promise((resolve) => {
    let hasBeingSolved = false;
    const extraFunctionDefinitions = {
        onComputeCallback: ({ entryVars: { returnValue } }) => {
            hasBeingSolved = true;
            resolve(returnValue);
        },
    };
    const processes = (functionEntryVar.process || [])
        .reduce((result, processId) => {
        const process = (0, createRunnableProcess_1.default)({
            store,
            processor,
            functionId: processId,
            extraFunctionDefinitions,
            functionsDefinitions,
        });
        if (process) {
            result.push(process);
        }
        return result;
    }, []);
    (0, executeProcessesFactory_1.default)({
        store,
        processor,
        controlCallerId,
        eventOutputs,
        itemContext,
        lastFunctionsOutputs,
    })(undefined, processes);
    setTimeout(() => {
        if (!hasBeingSolved) {
            resolve(undefined);
        }
    }, 30000);
});
exports.default = buildFunctionEvaluator;
